(function($, Drupal, window, document, drupalSettings) {
  Drupal.behaviors.babysleepcontent = {
    attach: function (context) {   

      $(once('bind-click-event', '.toggle-download-links', context)).each(function () {
        $(this).on('click', function() {         
          console.log('toggle-download-links');
          $('.links-wrapper').fadeToggle();
          return false;
        });
      });     
            

    }
  }

})(jQuery, Drupal, this, this.document, drupalSettings);

jQuery.fn.extend({
  treed: function (o) {
      
        var openedClass = "fa-minus";
        var closedClass = "fa-plus";
        var selectedClass = "selected"; // Add the selected class

        if (o && o.openedClass) openedClass = o.openedClass;
        if (o && o.closedClass) closedClass = o.closedClass;

        // initialize each of the top levels
        var tree = jQuery(this).addClass("sidebar_acc");
        tree.find("li:has(ul)").addClass("branch").click(function (e) {
            if (this == e.target) {
                var icon = jQuery(this).children("i:first");
                icon.toggleClass(openedClass + " " + closedClass);
                jQuery(this).children().children().slideToggle(200); // Adjust the speed (e.g., 200 milliseconds)

                // Add the selected class to the parent branch
                jQuery(this).siblings().removeClass(selectedClass);
                jQuery(this).toggleClass(selectedClass);
            }
        }).children().children().toggle();

        // fire event from the dynamically added icon
        tree.find(".branch .indicator").click(function () {
          jQuery(this).closest("li").click();
        });

        // fire event to open branch if the li contains an anchor or button
        tree.find(".branch > i").click(function (e) {
          jQuery(this).closest("li").click();
            e.preventDefault();
        });

        // Keep the selected branch open by default
        tree.find(".branch.selected").children().children().show();

       

  }
});

// Initialization of treeviews
jQuery("#tree_map").treed();
